import {
  Survey,
  SurveyQualificationsFormState,
  SurveyQuotasFormState,
} from '@ps/survey-utils';

export function buildQualificationsFormStateFromSurvey(
  survey: Survey,
): SurveyQualificationsFormState {
  return { value: survey.qualifications ?? [], valid: true, errors: [] };
}

export function buildQuotasFormStateFromSurvey(
  survey: Survey,
): SurveyQuotasFormState {
  return { value: survey.quotas ?? [], valid: true, errors: [] };
}
